import { AppError, err, ok, type ErrorDetail, type Result } from '@aibi/shared';
import type { z } from 'zod';

export const issuesToDetails = (issues: readonly z.core.$ZodIssue[]): ErrorDetail[] =>
  issues.map((issue) => ({
    path: issue.path.map(String).join('.'),
    message: issue.message,
  }));

/**
 * Valida un valor desconocido contra un contrato y devuelve un `Result` con errores
 * normalizados. Es la puerta de entrada obligatoria para datos externos
 * (HTTP, archivos, respuestas de IA, plugins).
 *
 * @example
 * const result = parseContract(SemanticModelSchema, JSON.parse(raw));
 * if (!result.ok) console.error(result.error.details);
 */
export function parseContract<S extends z.ZodType>(
  schema: S,
  input: unknown,
  contractName = 'contrato',
): Result<z.output<S>, AppError> {
  const parsed = schema.safeParse(input);
  return parsed.success
    ? ok(parsed.data)
    : err(
        new AppError('VALIDATION_ERROR', `El documento no cumple el ${contractName}.`, {
          details: issuesToDetails(parsed.error.issues),
        }),
      );
}
